import request from '@/utils/request'
import qs from 'qs'

/* 3d 热门和专题推荐 */
export function getThreeDRecommend(query) {
  return request({
    url: '?m=Dropdown&a=recommend3D',
    method: 'get',
    params: query
  })
}


export function getThreeDClassifyList(query) {
  return request({
    url: '?m=Dropdown&a=homePage3D',
    method: 'get',
    params: query
  })
}

/* 更新二级分类下的四张图片 */
export function getThreeDClassifyPicList(query) {
  return request({
    url: '?m=Dropdown&a=pictures3D',
    method: 'get',
    params: query
  })
}
